export function getStatusOfAcapellaStack(acapellaStack) {
    const {acapella_stack_jobs: acapellaStackJobs} = acapellaStack;
    if (acapellaStackJobs?.length > 0) {
        // Check if has mixdown job
        for (const acapellaStackJob of acapellaStackJobs) {
            // Check if mixdown preview in users voice
            if (acapellaStackJob.job?.type === 'acapella-stack-preview-mixer') {
                // TODO what if multiple mixdowns?
                // If mixdown is STARTED or COMPLETED, return status
                let mixdownStatus = acapellaStackJob.job?.status
                if (mixdownStatus === 'STARTED' || mixdownStatus === 'COMPLETED') {
                    return mixdownStatus
                }
            }
        }

        // mixdown is either CREATED or not there
        let vocalStemPreviewJobs = []
        for (const acapellaStackJob of acapellaStackJobs) {
            if (acapellaStackJob.input?.type === 'vocal-stem-preview') {
                // @ts-ignore
                vocalStemPreviewJobs.push(acapellaStackJob)
            }
        }
        // if has vocal-stem-preview jobs
        // status is CREATED if all are CREATED
        if (vocalStemPreviewJobs.length > 0) {
            // @ts-ignore
            if (vocalStemPreviewJobs.filter(a => a.job?.status === 'FAILED').length > 0) {
                return 'FAILED'
            }
            // @ts-ignore
            if (vocalStemPreviewJobs.filter(a => a.job?.status !== 'CREATED').length > 0) {
                return 'STARTED'
            }
        }
        // default to CREATED
        return 'CREATED'
    } else {
        return 'EMPTY'
    }
}

export function getPreviewUrlOfAcapellaStack(acapellaStack) {
    const {acapella_stack_jobs: acapellaStackJobs} = acapellaStack;
    if (acapellaStackJobs?.length > 0) {
        // Check if has mixdown job
        for (const acapellaStackJob of acapellaStackJobs) {
            // Check if mixdown preview in users voice
            if (acapellaStackJob.job?.type === 'acapella-stack-preview-mixer') {
                // TODO what if multiple mixdowns?
                // If mixdown is STARTED or COMPLETED, return status
                let mixdownStatus = acapellaStackJob.job?.status
                if (mixdownStatus === 'COMPLETED') {
                    return acapellaStackJob.job.audio_file_output[0].audio_file.storagePublicUrl
                }
            }
        }
    }
    return '';
}